<div class="dialog-header">
  <h2 mat-dialog-title>{{ 'global.applications' | translate }}</h2>

  <button mat-icon-button (click)="onClose()" class="close-icon">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="dialog-content">
  <itfg-data-table
    #dataTable
    [data]="applications"
    [columns]="displayedColumns"
  >
    <ng-template itfgDataTableTemplate="id" let-id="value" let-row="row">
      {{ id }}
    </ng-template>

    <ng-template
      itfgDataTableTemplate="createTime"
      let-createTime="value"
      let-row="row"
    >
      {{ createTime | date: 'dd.MM.yyyy' }}
    </ng-template>

    <ng-template
      itfgDataTableTemplate="principal"
      let-principal="value"
      let-row="row"
    >
      {{ principal | toCustomItfgCurrency }}
    </ng-template>

    <ng-template
      itfgDataTableTemplate="source"
      let-source="value"
      let-row="row"
    >
      {{ source?.name }}
    </ng-template>

    <ng-template
      itfgDataTableTemplate="partner"
      let-partner="value"
      let-row="row"
    >
      {{ partner?.name || 'N/A' }}
    </ng-template>

    <ng-template
      itfgDataTableTemplate="status"
      let-status="value"
      let-row="row"
    >
      {{ status?.name }}
    </ng-template>
  </itfg-data-table>
</div>

<div class="dialog-actions">
  <button mat-button (click)="onClose()">
    {{ 'global.close' | translate }}
  </button>
</div>
